module.exports = __webpack_public_path__ + "static/media/question-icon.5b81a197.svg";